<div fxLayout="row" fxLayoutAlign="start center" >
  <button mat-button  *ngFor="let folder of folderList" (click)="onClick(folder)">{{folder.Name}}</button>
</div>
